export const IMMIGRATION_QUESTION = 6;
export const ETHIOPIA_ANSWER = 2;
export const RECENTLT_IMMIGRATED = 0;